var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-favorite",class:{'active' : _vm.isFav},on:{"click":_vm.addToFavs}})
}
var staticRenderFns = []

export { render, staticRenderFns }